/**
 * Инициализация поведения хэдера при прокрутке страницы
 */
export function initFixedHeader() {
  const header = getHeader();
  const isNavBar = header.hasClass('header__nav-bar');
  const headerPlaceholder = isNavBar ? $('.header__nav-bar-placeholder') : null;
  const content = $('body');

  const headerClasses = getHeaderClasses(isNavBar);
  const headerHeight = header.outerHeight();

  let animated = false;

  function setHeaderHidden() {
    if (isNavBar) {
      if (header.hasClass(headerClasses.fixed)) {
        header.addClass(headerClasses.animated);
      }
      header.addClass(headerClasses.fixed).addClass(headerClasses.hidden);
      headerPlaceholder.addClass('header__nav-bar-placeholder--visible');
    } else {
      header.removeClass(headerClasses.fixed).addClass(headerClasses.hidden);
      content.css('padding-top', 0);
    }

    animated = false;
  }

  function setHeaderFixed() {
    if (isNavBar) {
      header.addClass(headerClasses.animated).addClass(headerClasses.fixed).removeClass(headerClasses.hidden);
      headerPlaceholder.addClass('header__nav-bar-placeholder--visible');
    } else {
      header.addClass(headerClasses.fixed).removeClass(headerClasses.hidden);
      content.css('padding-top', headerHeight);
    }

    animated = false;
  }

  function setHeaderDefault() {
    if (isNavBar) {
      header.removeClass(headerClasses.animated);
      header.removeClass(headerClasses.fixed).removeClass(headerClasses.hidden);
      headerPlaceholder.removeClass('header__nav-bar-placeholder--visible');
    } else {
      header.removeClass(headerClasses.fixed).removeClass(headerClasses.hidden);
      content.css('padding-top', 0);
    }

    animated = false;
  }

  function shouldSetHeaderDefault(scrollTop) {
    if (scrollTop <= 0) {
      return true;
    } else if (!isNavBar) {
      return false;
    } else {
      const rectPlaceholder = headerPlaceholder[0].getBoundingClientRect();

      if (rectPlaceholder.height) {
        return rectPlaceholder.top >= 0;
      } else {
        const rectNavBar = header[0].getBoundingClientRect();
        return rectNavBar.top >= 0;
      }
    }
  }

  let lastScrollTop = 0;
  let timeout;
  $(window).scroll(function () {
    const scrollTop = $(this).scrollTop();

    if (shouldSetHeaderDefault(scrollTop)) {
      if (timeout) clearTimeout(timeout);
      setTimeout(setHeaderDefault, 0);
    } else if (!animated) {
      animated = true;

      if (scrollTop > lastScrollTop) {
        // Скроллим вниз (не в верхней точке)
        timeout = setTimeout(setHeaderHidden, 300);
      } else {
        // Скроллим вверх (не в верхней точке)
        timeout = setTimeout(setHeaderFixed, 300);
      }
    }

    lastScrollTop = scrollTop;
  });
}

function getHeader() {
  const headerNavBar = $('.header__nav-bar');
  if (headerNavBar.length) return headerNavBar;

  return $('.header-main');
}

/**
 * @param {boolean} isNavBar
 * @return {{ hidden: string, fixed: string, animated?: string }}
 */
function getHeaderClasses(isNavBar) {
  return isNavBar
    ? {
        hidden: 'header__nav-bar--hidden',
        fixed: 'header__nav-bar--fixed',
        animated: 'header__nav-bar--animated',
      }
    : {
        hidden: 'header-main__hidden',
        fixed: 'header-main__fixed',
      };
}
